// Reducer for the saved-filters cluster: the loaded filter list, the per-filter
// enabled map, and the id whose schedule-override modal is open. These three drive
// the Job Filters section and its modal together.

export const initialFiltersState = {
    savedFilters: [],
    enabledFilters: {},
    activeConfigFilter: null,
};

export function filtersReducer(state, action) {
    switch (action.type) {
        case 'SET_SAVED_FILTERS':
            return { ...state, savedFilters: action.value };
        case 'SET_ENABLED_FILTERS':
            // Supports both a replacement object and a functional updater so the
            // optimistic-toggle `prev => ({...prev})` semantics are preserved exactly.
            return {
                ...state,
                enabledFilters: typeof action.value === 'function'
                    ? action.value(state.enabledFilters)
                    : action.value,
            };
        case 'SET_ACTIVE_CONFIG_FILTER':
            return { ...state, activeConfigFilter: action.value };
        default:
            return state;
    }
}
